import { helpers } from 'vuelidate/lib/validators'

export * from 'vuelidate/lib/validators'

export const requiredUppercase = helpers.regex('requiredUppercase', /[A-Z]/)
export const regex = value => helpers.value('regex', regex)
